import ApiService from './ApiService'

const api = ApiService

export const createInvite = ({ token, user_id }) => {
  return api.get(`/videocall/new/${user_id}`, {}, { headers: { Authorization: `Bearer ${token}` } })
}
